import React from "react";
import './Calculator.css';

function Calculator() {
    return (
        <div className="calculator">
            <div className="calculator-icon">IC</div>
        </div>
    )
}

export default Calculator;